import { Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AnsiUp } from 'ansi_up';

import { NotebookVizResult } from '@mode/notebooks/domain';

@Directive({
  selector: '[modeNotebookCellResultContent]',
})
export class NotebookCellResultContentDirective implements OnInit, OnChanges {
  @Input()
  modeNotebookCellResultContent!: NotebookVizResult;
  private ansi_up = new AnsiUp();
  constructor(private el: ElementRef<HTMLInputElement>) {}

  ngOnInit() {
    this.ansi_up.use_classes = true;
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.el.nativeElement.innerHTML = this.ansi_up?.ansi_to_html(
      this.modeNotebookCellResultContent?.content?.toString()
    );
  }
}
